import {globalColors as tokensGlobalColors} from '@volkswagen-onehub/tokens'

export const globalColors = {
    ...tokensGlobalColors,
    blue600: tokensGlobalColors.blue['600'],
    grey100: tokensGlobalColors.grey['100'],
    mint100: tokensGlobalColors.mint['100'],
    purple100: tokensGlobalColors.purple['100'],
    white000: tokensGlobalColors.white['000'],
}
